import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'trustResource' })
export class TrustResourcePipe implements PipeTransform {
    public constructor(
        private readonly domSanitizer: DomSanitizer) {}

    public transform(value: string): SafeResourceUrl | void {
        if (value) return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
    }
}
